var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronsRight = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.71967 17.4697C4.42678 17.7626 4.42678 18.2374 4.71967 18.5303C5.01256 18.8232 5.48744 18.8232 5.78033 18.5303L11.7803 12.5303C12.0732 12.2374 12.0732 11.7626 11.7803 11.4697L5.78033 5.46967C5.48744 5.17678 5.01256 5.17678 4.71967 5.46967C4.42678 5.76256 4.42678 6.23743 4.71967 6.53033L10.1893 12L4.71967 17.4697ZM12.2197 17.4697C11.9268 17.7626 11.9268 18.2374 12.2197 18.5303C12.5126 18.8232 12.9874 18.8232 13.2803 18.5303L19.2803 12.5303C19.5732 12.2374 19.5732 11.7626 19.2803 11.4697L13.2803 5.46967C12.9874 5.17678 12.5126 5.17678 12.2197 5.46967C11.9268 5.76256 11.9268 6.23744 12.2197 6.53033L17.6893 12L12.2197 17.4697Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronsRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevrons-right.df8b9dd6822b79a9c06f8b517c813a28.svg";